module.exports = __webpack_public_path__ + "SpongexResize_opt.jpg?f99408f7e2fb161a8012d09ef19733a9";


//////////////////
// WEBPACK FOOTER
// ./src/img/SpongexResize_opt.jpg
// module id = 367
// module chunks = 0